import axios from 'axios';

const BASE_PATH = '/api/v2/academy';

export default class AcademyAPI {
    static getCourses(category) {
        return new Promise((resolve, reject) => {
            const params = category ? `?category=${encodeURIComponent(category)}` : '';
            axios.get(`${BASE_PATH}/courses${params}`)
                .then(res => {
                    if (res && res.data) {
                        resolve(res.data);
                    } else {
                        reject(new Error("Respuesta inválida del servidor"));
                    }
                })
                .catch(err => reject(err));
        });
    }

    static getCourse(id) {
        return new Promise((resolve, reject) => {
            axios.get(`${BASE_PATH}/courses/${id}`)
                .then(res => {
                    if (res && res.data) {
                        resolve(res.data);
                    } else {
                        reject(new Error("Respuesta inválida del servidor"));
                    }
                })
                .catch(err => reject(err));
        });
    }

    static getProgress() {
        return new Promise((resolve, reject) => {
            axios.get(`${BASE_PATH}/progress`)
                .then(res => {
                    if (res && res.data) {
                        resolve(res.data);
                    } else {
                        reject(new Error("Respuesta inválida del servidor"));
                    }
                })
                .catch(err => reject(err));
        });
    }

    static completeVideo(courseId, videoId) {
        return new Promise((resolve, reject) => {
            axios.post(`${BASE_PATH}/courses/${courseId}/videos/${videoId}/complete`)
                .then(res => {
                    if (res && res.data) {
                        resolve(res.data);
                    } else {
                        reject(new Error("Respuesta inválida del servidor"));
                    }
                })
                .catch(err => reject(err));
        });
    }

    static enrollCourse(courseId) {
        return new Promise((resolve, reject) => {
            axios.post(`${BASE_PATH}/courses/${courseId}/enroll`)
                .then(res => {
                    if (res && res.data) {
                        resolve(res.data);
                    } else {
                        reject(new Error("Respuesta inválida del servidor"));
                    }
                })
                .catch(err => reject(err));
        });
    }
}
